import { render, staticRenderFns } from "./received-quantity-modal.vue?vue&type=template&id=c86a6e06&scoped=true"
import script from "./received-quantity-modal.vue?vue&type=script&lang=js"
export * from "./received-quantity-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86a6e06",
  null
  
)

export default component.exports